import { v5 as uuidv5 } from 'uuid';

export const SPREAD_PREVIEW_GENERATION_CAPABILITY = 'spread-preview-generation-v1' as const;

const SPREAD_PREVIEW_FILE_NAMESPACE: string = uuidv5('FOTOCLASS:spread-preview@v2', uuidv5.URL);
const SPREAD_PREVIEW_SLUG_PREFIX = 'spread-preview';

export type SpreadPreviewSize = 'large' | 'medium' | 'thumb';

export interface SpreadPreviewIdentity {
  albumId: string;
  spreadUuid: string;
  generation: string;
  size: SpreadPreviewSize;
}

export function spreadPreviewFileId(identity: SpreadPreviewIdentity): string {
  const { albumId, spreadUuid, generation, size } = identity;
  return uuidv5(`${albumId}:${spreadUuid}:${generation}:${size}`, SPREAD_PREVIEW_FILE_NAMESPACE);
}

export function spreadPreviewSlug(identity: SpreadPreviewIdentity): string {
  const { albumId, spreadUuid, generation, size } = identity;
  return `${spreadPreviewSlugPrefix(albumId, spreadUuid)}${generation}:${size}`;
}

export function spreadPreviewSlugPrefix(albumId: string, spreadUuid: string): string {
  return `${SPREAD_PREVIEW_SLUG_PREFIX}:${albumId}:${spreadUuid}:`;
}

// Серверный рендер кладёт разворот под сегмент generation-<hash(modelVersion)>: ключ адресует ИМЕННО тот
// рендер, а не «последнее превью этого разворота».
const GENERATION_ADDRESSED_PREVIEW_PATH =
  /\/generation-[a-f\d]{20}\/previews\/[a-f\d-]{36}\/(?:thumb|medium|large)\.webp(?:\?.*)?$/i;
// Редакторская загрузка адресуется fileId = uuidv5(album:spread:generation:size) со СЛУЧАЙНОЙ generation,
// то есть каждый захват попадает в собственный, никогда прежде не запрошенный ключ storage.
const UPLOADED_PREVIEW_PATH = /\/spread-preview-(?:thumb|medium|large)\//i;

export function isGenerationAddressedPreviewPath(path: string): boolean {
  return GENERATION_ADDRESSED_PREVIEW_PATH.test(path);
}

/**
 * Ключ, который по построению не может держать байты никакого другого рендера. Отсюда главное следствие:
 * доказательством готовности такого превью служит сам факт, что объект отдаётся, — сверять его
 * Last-Modified с моментом коммита записи бессмысленно (коммит всегда позже записи байтов).
 */
export function isImmutablePreviewPath(path: string): boolean {
  return isGenerationAddressedPreviewPath(path) || UPLOADED_PREVIEW_PATH.test(path);
}
